import { Center, Flex, Image } from '@chakra-ui/react';
import { ReactComponent as PlaylistCoverIcon } from 'resources/images/playlist.svg';
import React from 'react';
import { AudioActionButton } from 'app/components/Song/Audio/AudioActionButton';

interface PlaylistCoverActionButtonProps {
  isAudioPlaying: boolean;
  isLoading?: boolean;
  playable: boolean;
  image?: string;
}

const DefaultPlaylistCover = () => (
  <Center
    width={10}
    height={10}
    minWidth={10}
    minHeight={10}
    px={2}
    flexDirection="column"
    rounded={2}
    bg="surface2"
    color="P.40"
    overflow="hidden"
    sx={{
      svg: {
        width: '100%',
        height: '100%',
      },
    }}
  >
    <PlaylistCoverIcon />
  </Center>
);

export const PlaylistCoverActionButton = ({
  isAudioPlaying,
  isLoading,
  playable,
  image,
}: PlaylistCoverActionButtonProps) => {
  if (!playable) {
    return (
      <Image
        src={image}
        alt="playlist cover"
        fallback={<DefaultPlaylistCover />}
        borderRadius="4px"
      />
    );
  }

  return (
    <Center width={10} height={10} overflow="visible" role="group">
      <Flex
        role="button"
        position="relative"
        zIndex={1}
        transition="all .2s ease-in-out"
      >
        <Image
          src={image}
          alt="playlist cover"
          fallback={<DefaultPlaylistCover />}
          sx={{
            transition: 'opacity .2s ease-in-out',
            _groupHover: {
              opacity: 0.72,
            },
          }}
        />

        <AudioActionButton
          data-testid="playlists-list-audio-play-button"
          size={24}
          playing={isAudioPlaying}
          isLoading={isLoading}
          variant="cover"
          spinnerProps={{
            sx: {
              position: 'absolute',
              top: 2,
              left: 2,
              bg: 'transparent',
            },
          }}
          sx={{
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            top: '50%',
            left: '50%',
            _hover: {
              transform: 'translate(-50%, -50%) scale(1.02)',
            },
            _groupHover: {
              transform: 'translate(-50%, -50%) scale(1.02)',
            },
          }}
        />
      </Flex>
    </Center>
  );
};
